import { render, staticRenderFns } from "./Hard8th_Orders.vue?vue&type=template&id=0bfda416&scoped=true"
import script from "./Hard8th_Orders.vue?vue&type=script&lang=js"
export * from "./Hard8th_Orders.vue?vue&type=script&lang=js"
import style0 from "./Hard8th_Orders.vue?vue&type=style&index=0&id=0bfda416&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfda416",
  null
  
)

export default component.exports